// extracted by mini-css-extract-plugin
export default {"root":"instructionDetails_root__bb3iX","content":"instructionDetails_content__Ovojz"};